// eslint-disable-next-line import/no-anonymous-default-export
export default {
    ADD_LIFE_EVENT: "ADD_LIFE_EVENT",
    GET_LIFE_EVENTS: "GET_LIFE_EVENTS",
    RESET_RECENTLY_ADDED: "RESET_RECENTLY_ADDED",
    GET_EMOTION_TYPES: "GET_EMOTION_TYPES",
    DELETE_LIFE_EVENT: "DELETE_LIFE_EVENT",
    GET_EVENT_CATEGORIES: "GET_EVENT_CATEGORIES"
  };
  